<template>
    <v-container>
        <div class="text-left" style="margin-bottom:20px;">
            <router-link to="/iceland">
                    <v-btn
                        color="secondary"
                        class="text-right"
                        style="width:250px"
                    >
                        Back
                    </v-btn>
            </router-link>
        </div>   
        <v-row>
            <v-col cols="12" class="text-left">
                Las Vegas to London Norse Z0778 4:45pm arrives London (LGW) Jan 31 10:35am
            </v-col>
            <v-col cols="12" class="text-left">
                London (LGW) to Reykjavik Easyjet EZY8843 3:05pm arrives London (LGW) Jan 31 6:30pm
            </v-col>
        </v-row>        
    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'IcelandFlights',
    setup() {
    }
  }
  </script>